import { Button, Popconfirm, message } from "antd";
import axios from "axios";
import MessageReadStatus from "../../../../components/readreceipts/MessageReadStatus";
import moment from "moment";
import React, { useState } from "react";
import { AiOutlineClose, AiOutlineFilePdf } from "react-icons/ai";
import { useQuery, useQueryClient } from "react-query";
import { cloudFrontUrl, serverUrl } from "../../../../nestserver";
import ImagePreviewModal from "./modals/ImagePreviewModal";
import VideoPreviewModal from "./modals/VideoPreviewModal";

const SentAnnouncements = () => {
  const queryClient = useQueryClient();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const fetchMessages = async () => {
    const res = await axios.get(
      serverUrl + `/personal-messages?type=sent&limit=100&skip=0`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      },
    );
    return res.data;
  };
  const messagesQuery = useQuery(["personal-messages", "sent"], fetchMessages, {
    enabled: true,
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
  });

  const handleDeleteMessage = async (messageId) => {
    try {
      await axios.delete(serverUrl + "/personal-messages/" + messageId, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      });
      message.success("Message deleted successfully");
      queryClient.invalidateQueries(["personal-messages", "sent"]);
      setSelectedMessage(null);
    } catch (err) {
      console.error(err);
      message.error("Failed to delete message");
    }
  };

  const getMediaInfo = (item) => {
    let folder = "images";
    let mediaType = item?.type;
    if (item?.type) {
      if (item.type === "IMAGE") folder = "images";
      else if (item.type === "PDF") folder = "pdf";
      else if (item.type === "VIDEO") folder = "video";
      else if (item.type === "AUDIO" || item.type === "VOICE") folder = "audio";
    } else {
      const name = item?.name?.toLowerCase() || "";
      if (name.endsWith(".pdf")) {
        folder = "pdf";
        mediaType = "PDF";
      } else if (name.endsWith(".mp4")) {
        folder = "video";
        mediaType = "VIDEO";
      } else if (name.endsWith(".mp3")) {
        folder = "audio";
        mediaType = "AUDIO";
      } else if (name.endsWith(".wav") || name.endsWith(".webm")) {
        folder = "audio";
        mediaType = "VOICE";
      } else if (
        name.endsWith(".jpeg") ||
        name.endsWith(".jpg") ||
        name.endsWith(".png")
      ) {
        folder = "images";
        mediaType = "IMAGE";
      }
    }
    return { folder, mediaType };
  };

  return (
    <div className="mt-8">
      <div
        style={{ borderRadius: "10px", color: "#616161", overflow: "hidden" }}
        className="bg-white drop-shadow-md p-8 w-full screen-height"
      >
        <div className="flex gap-4 min-height">
          {/* Sidebar */}
          <div
            style={{ width: "30%", overflow: "hidden" }}
            className="message-left-part"
          >
            <h2 className="text-xl font-bold m-0 text-gray-800 mb-6">
              Sent Announcements
            </h2>

            <div style={{ height: "calc(100% - 60px)", overflowY: "auto" }}>
              {messagesQuery?.data?.result?.data?.map((msg) => (
                <div
                  key={msg._id}
                  onClick={() => setSelectedMessage(msg)}
                  className={`cursor-pointer pt-2 ${
                    selectedMessage?._id === msg._id
                      ? "active-message"
                      : "message-card"
                  }`}
                >
                  <div className="flex justify-between">
                    <div className="flex-1" style={{ minWidth: 0 }}>
                      <div className="font-semibold">{msg.subject}</div>
                      <div className="text-sm text-gray-500 truncate">
                        {msg.message}
                      </div>
                      <div className="text-xs text-gray-400 flex items-center gap-2">
                        {moment(msg.createdAt).format("DD-MM-YYYY HH:mm")}
                        <MessageReadStatus
                          message={msg}
                          readInfoPath={`/personal-messages/${msg._id}/read-info`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Details Area */}
          <div style={{ flex: 1 }} className="instructor-broadcast">
            {selectedMessage ? (
              <div>
                <div className="flex justify-between items-center pb-4">
                  <h1 className="text-base font-semibold">Message Details</h1>
                  <div className="flex gap-4">
                    <Popconfirm
                      title="Are you sure to delete this message?"
                      onConfirm={() => handleDeleteMessage(selectedMessage._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        danger
                      >
                        Delete
                      </Button>
                    </Popconfirm>
                    <AiOutlineClose
                      size={20}
                      onClick={() => setSelectedMessage(null)}
                      className="cursor-pointer"
                    />
                  </div>
                </div>

                <div
                  className="border rounded p-6 shadow-sm bg-white overflow-y-auto"
                  style={{ maxHeight: "calc(100vh - 250px)" }}
                >
                  <div className="flex flex-col gap-6">
                    <div className="border-b pb-4">
                      <label className="text-gray-500 text-xs uppercase tracking-wider font-bold">
                        Subject
                      </label>
                      <div className="text-xl font-medium text-gray-800 mt-1">
                        {selectedMessage.subject}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-6">
                      <div>
                        <label className="text-gray-500 text-xs uppercase tracking-wider font-bold">
                          From
                        </label>
                        <div className="text-base text-gray-800 mt-1 font-medium">
                          {selectedMessage.sender_id?.first_name}{" "}
                          {selectedMessage.sender_id?.last_name}
                        </div>
                      </div>
                      <div>
                        <label className="text-gray-500 text-xs uppercase tracking-wider font-bold">
                          Date
                        </label>
                        <div className="text-base text-gray-800 mt-1 font-medium flex items-center gap-2">
                          {moment(selectedMessage.createdAt).format(
                            "DD-MM-YYYY HH:mm",
                          )}
                          <MessageReadStatus
                            message={selectedMessage}
                            readInfoPath={`/personal-messages/${selectedMessage._id}/read-info`}
                          />
                        </div>
                      </div>
                    </div>

                    {selectedMessage.recipient_ids?.length > 0 && (
                      <div>
                        <label className="text-gray-500 text-xs uppercase tracking-wider font-bold mb-2 block">
                          Recipients
                        </label>
                        <div className="flex flex-wrap gap-2">
                          {selectedMessage.recipient_ids.map(
                            (recipient, index) => (
                              <div
                                key={index}
                                className="inline-flex items-center bg-blue-50 border border-blue-200 rounded-full px-3 py-1"
                              >
                                <span className="text-sm text-blue-700 font-medium">
                                  {recipient?.first_name} {recipient?.last_name}
                                </span>
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    )}

                    <div>
                      <label className="text-gray-500 text-xs uppercase tracking-wider font-bold mb-2 block">
                        Message
                      </label>
                      <div className="p-4 bg-gray-50 rounded-lg whitespace-pre-wrap text-gray-700 leading-relaxed border border-gray-100">
                        {selectedMessage.message}
                      </div>
                    </div>

                    {selectedMessage.media?.length > 0 && (
                      <div>
                        <label className="text-gray-500 text-xs uppercase tracking-wider font-bold mb-3 block">
                          Attachments
                        </label>
                        <div className="flex flex-wrap gap-4">
                          {selectedMessage.media.map((file, index) => {
                            const { folder, mediaType } = getMediaInfo(file);
                            const mediaUrl = `${cloudFrontUrl}/${folder}/${file.id}`;

                            return (
                              <div key={index} className="inline-media">
                                {mediaType === "VIDEO" ? (
                                  <div
                                    className="relative cursor-pointer"
                                    onClick={() => {
                                      setSelectedVideo(mediaUrl);
                                      setVideoModalVisible(true);
                                    }}
                                    style={{ width: "100px", height: "100px" }}
                                  >
                                    <video
                                      src={mediaUrl}
                                      className="rounded border"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                ) : mediaType === "PDF" ? (
                                  <a
                                    href={mediaUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-link flex items-center gap-2 border p-2 rounded bg-gray-50"
                                    style={{ maxWidth: "200px" }}
                                  >
                                    <AiOutlineFilePdf size={20} />
                                    <span className="truncate text-sm">
                                      {file.name}
                                    </span>
                                  </a>
                                ) : mediaType === "AUDIO" ||
                                  mediaType === "VOICE" ? (
                                  <div className="flex flex-col gap-1">
                                    <audio controls style={{ maxWidth: "200px" }}>
                                      <source src={mediaUrl} />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                    <span
                                      className="text-xs text-gray-500 truncate"
                                      style={{ maxWidth: "200px" }}
                                    >
                                      {file.name}
                                    </span>
                                  </div>
                                ) : (
                                  <img
                                    src={mediaUrl}
                                    alt={file.name}
                                    onClick={() => {
                                      setImageModalSrc(mediaUrl);
                                      setImageModalVisible(true);
                                    }}
                                    className="cursor-pointer rounded border"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center h-full text-gray-400 gap-4">
                <div className="text-6xl">💬</div>
                <p className="text-lg">
                  Select a message from the sidebar to view details
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <ImagePreviewModal
        visible={imageModalVisible}
        imageSrc={imageModalSrc}
        onClose={() => setImageModalVisible(false)}
      />

      <VideoPreviewModal
        visible={videoModalVisible}
        videoSrc={selectedVideo}
        onClose={() => setVideoModalVisible(false)}
      />
    </div>
  );
};

export default SentAnnouncements;
